module.exports = ":host {\n  display: block; }\n\nimg {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  pointer-events: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/poster-image/poster-image.component.scss
// module id = ./src/app/poster-image/poster-image.component.scss
// module chunks = main